import { ConsultantCard } from "@/ui/ConsultantCard";
import { Form } from "@/ui/Form";
import SF_SocialShareCard_001 from "@/ui/SF_SocialShareCard_001";
import cn from "classnames";
import { useRouter } from "next/router";
import { Col, Container, Row, Stack } from "react-bootstrap";

import classes from "./styles.module.scss";

export default function ({
  className = "pb-5 pb-lg-6",
  id,
  description,
  consultant,
  EditableText,
  theme = "light",
  skills,
  sectors
}) {
  const router = useRouter();

  return (
    <div className={cn(className, classes.JobPostContent)} data-bs-theme={theme}>
      <Container fluid="md">
        <Row className="flex-column flex-lg-row">
          <Col xs={12} lg={8} className="border-end pe-lg-5">
            <div className="mb-5" dangerouslySetInnerHTML={{ __html: description }} />
            <div className="mb-5">
              <EditableText tag="p" path="side.note" className="bg-light p-4">
                Hyper Recruitment Solutions Ltd (HRS) is an Equal Opportunities employer. We welcome applications from anyone who meets the role requirements. HRS exclusively supports the STEM sectors, combining recruitment expertise with scientific knowledge to help you advance your career.
              </EditableText>
            </div>
          </Col>
          <Col xs={12} lg={4} className="ps-lg-5">
            {consultant && (
              <div className="mb-4">
                <EditableText tag="h4" path="consultant_title" className="mb-4">
                  Your Recruitment Consultant
                </EditableText>
                <ConsultantCard className="ps-0 pe-3" {...consultant} />
              </div>
            )}
            <div>
              <a id="apply" />
              <EditableText tag="h3" path="apply_title" className="mb-4">
                Apply for this job
              </EditableText>
              <Form
                jobId={id}
                onSubmitDone={() => {
                  router.replace("/application-complete/");
                }}
              />
              {(sectors.length >= 1 || skills.length >= 1) && (
                <div className="mt-4 mb-5 mb-lg-0">
                  {sectors.length >= 1 && (
                    <div className="d-flex gap-2 post-tags mb-4">
                      <strong>Sectors:</strong>
                      <div className="d-flex flex-wrap gap-2">
                        {...sectors.map((post, index) =>
                          <span key={index}>
                            {post.name}
                            {index !== skills.length - 1 && ","}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                  {skills.length >= 1 && (
                    <div className="d-flex gap-2 post-tags">
                      <strong>Skills:</strong>
                      <div className="d-flex flex-wrap gap-2">
                        {...skills.map((post, index) =>
                          <span key={index}>
                            {post.value}
                            {index !== skills.length - 1 && ","}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
              {/* {(sectors.length >= 1 || skills.length >= 1) && (
                <div className="post-tags d-flex gap-2 mt-4">
                  {...sectors.map((post, index) =>
                    <span key={index} className="py-1 px-2">
                      {post.name}
                    </span>
                  )}
                  {...skills.map((post, index) =>
                    <span key={index} className="py-1 px-2">
                      {post.value}
                    </span>
                  )}
                </div>
              )} */}
            </div>
          </Col>
          <Col xs={12}>
            <Stack className="flex-row align-items-center gap-3 my-4 my-lg-0">
              <span className="xsmall fw-bold">Share this Job</span>
              <SF_SocialShareCard_001 />
            </Stack>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
